import unescapedText from 'I18n/utils/unescapedText';
import { useEffect } from 'react';
const getDocumentTitle = screen => {
  switch (screen) {
    case 'crm':
      return unescapedText('publicPricingPage.windowTitles.crm');
    case 'marketing':
      return unescapedText('publicPricingPage.windowTitles.marketing');
    case 'marketing-plus':
      return unescapedText('publicPricingPage.windowTitles.marketing-plus');
    case 'sales':
      return unescapedText('publicPricingPage.windowTitles.sales');
    case 'service':
      return unescapedText('publicPricingPage.windowTitles.service');
    case 'content':
      return unescapedText('publicPricingPage.windowTitles.content');
    case 'data':
      return unescapedText('publicPricingPage.windowTitles.data');
    case 'suite':
      return unescapedText('publicPricingPage.windowTitles.suite');
    case 'smart-crm':
      return unescapedText('publicPricingPage.windowTitles.smart-crm');
    case 'commerce':
      return unescapedText('publicPricingPage.windowTitles.commerce');
    default:
      return unescapedText('publicPricingPage.windowTitles.default');
  }
};
const resetTitle = () => {
  document.title = unescapedText('publicPricingPage.windowTitles.default');
};
export const usePublicDocumentTitle = screen => {
  const title = getDocumentTitle(screen);
  useEffect(() => {
    document.title = title;
    return resetTitle;
  }, [title]);
};